export default class Attachment {
    constructor (dto) {
        this.id = 0;
        this.documentId = 0;
        this.user = '';
        this.description = '';
        this.date = '';
        this.fileId = '';
        this.fileName = '';
        this.canDisplay = true;

        if (dto) {
            this.id = dto.id;
            this.documentId = dto.objectID;
            this.user = dto.userDisplayName;
            this.description = dto.description;
            this.date = dto.creationDate;
            this.canDisplay = dto.canDisplay;
        }
    }

    toDto () {
        return {
            Id: this.id,
            ObjectID: this.documentId,
            Description: this.description,
            FileID: this.fileId,
            FileName: this.fileName,
        };
    }
}
